import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import React, { Suspense, lazy, useEffect } from 'react';
import FloatingActionButton from "./Components/ReusableComponents/FAB/FloatingActionButton";
import Layout from "./Components/Layout/Layout";
import ScrollToTop from "./Components/ReusableComponents/ScrollToTop";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import SEO from "./Components/SEO/SEO";
import { initAnalytics } from "./utils/analytics";
import { createSkipLink } from "./utils/accessibility";
import { COMPANY_INFO } from "./constants";
import "./Components/ErrorBoundary/ErrorBoundary.css";
import ChildCompanyLanding from "./pages/Arrow/Arrow";
import JBVision from "./pages/JBVision/JBVision";
import JBConX from "./pages/JBConX/JBConX";
import Techsys from "./pages/Techsys/Techsys"

// Lazy load all page components
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const JBAS = lazy(() => import("./pages/Jbas/Jbas"));
const Arrow = lazy(() => import("./pages/Arrow/Arrow"));
//const JBVision = lazy(() => import("./pages/JBVision/JBVision"));
//const JBConX = lazy(() => import("./pages/JBConX/JBConX"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const About = lazy(() => import("./pages/About/About"));


// Loading component with animation
const LoadingFallback = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

const App = () => {
  useEffect(() => {
    // Initialize analytics
    initAnalytics();
    
    // Create skip link for accessibility
    createSkipLink();
  }, []);

  return (
    <ErrorBoundary>
      <SEO 
        title="Home"
        description="JBA Groups - Leading Construction and IT Solutions Provider in Bangalore"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": COMPANY_INFO.name,
          "url": window.location.origin,
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${window.location.origin}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        }}
      />
      <div className="App">
        <Router>
          <ScrollToTop />
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/Jbas" element={<JBAS />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/Arrow" element={<Arrow/>}/>
                <Route path="/JBVision" element={<JBVision/>}/>
                <Route path="/JBConX" element={<JBConX/>}/>
                <Route path="/Techsys" element={<Techsys/>} />
                
              </Route>
            </Routes>
          </Suspense>
          <FloatingActionButton />
        </Router>
      </div>
    </ErrorBoundary>
  );
};

export default App;
